module.exports = __webpack_public_path__ + "img/ai_speaking.731adfa6.png";